export const CREATE_REGISTER_REQUEST = 'CREATE_REGISTER_REQUEST'
export const CREATE_REGISTER_SUCCESS = 'CREATE_REGISTER_SUCCESS'
export const CREATE_REGISTER_ERROR = 'CREATE_REGISTER_ERROR'
export const CREATE_REGISTER_RESET = 'CREATE_REGISTER_RESET'

export const VALIDATE_REGISTER_REQUEST = 'VALIDATE_REGISTER_REQUEST'
export const VALIDATE_REGISTER_SUCCESS = 'VALIDATE_REGISTER_SUCCESS'
export const VALIDATE_REGISTER_ERROR = 'VALIDATE_REGISTER_ERROR'
export const VALIDATE_REGISTER_RESET = 'VALIDATE_REGISTER_RESET'

export const LIST_REGISTER_REQUEST = 'LIST_REGISTER_REQUEST'
export const LIST_REGISTER_SUCCESS = 'LIST_REGISTER_SUCCESS'
export const LIST_REGISTER_ERROR = 'LIST_REGISTER_ERROR'
export const LIST_REGISTER_RESET = 'LIST_REGISTER_RESET'

export const GENERATE_EXCEL_REQUEST = 'GENERATE_EXCEL_REQUEST'
export const GENERATE_EXCEL_SUCCESS = 'GENERATE_EXCEL_SUCCESS'
export const GENERATE_EXCEL_ERROR = 'GENERATE_EXCEL_ERROR'
export const GENERATE_EXCEL_RESET = 'GENERATE_EXCEL_RESET'

export const GET_REGISTER_BY_CPF_REQUEST = 'GET_REGISTER_BY_CPF_REQUEST'
export const GET_REGISTER_BY_CPF_SUCCESS = 'GET_REGISTER_BY_CPF_SUCCESS'
export const GET_REGISTER_BY_CPF_ERROR = 'GET_REGISTER_BY_CPF_ERROR'
export const GET_REGISTER_BY_CPF_RESET = 'GET_REGISTER_BY_CPF_RESET'

export const VERIFY_REGISTER_REQUEST = 'VERIFY_REGISTER_REQUEST'
export const VERIFY_REGISTER_SUCCESS = 'VERIFY_REGISTER_SUCCESS'
export const VERIFY_REGISTER_ERROR = 'VERIFY_REGISTER_ERROR'
export const VERIFY_REGISTER_RESET = 'VERIFY_REGISTER_RESET'

export const RESEND_SMS_REQUEST = 'RESEND_SMS_REQUEST'
export const RESEND_SMS_SUCCESS = 'RESEND_SMS_SUCCESS'
export const RESEND_SMS_ERROR = 'RESEND_SMS_ERROR'
export const RESEND_SMS_RESET = 'RESEND_SMS_RESET'

export const UPDATE_PHONE_REQUEST = 'UPDATE_PHONE_REQUEST'
export const UPDATE_PHONE_SUCCESS = 'UPDATE_PHONE_SUCCESS'
export const UPDATE_PHONE_ERROR = 'UPDATE_PHONE_ERROR'
export const UPDATE_PHONE_RESET = 'UPDATE_PHONE_RESET'
